import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

import { environment } from '@env/environment';
import { Parameter } from '@games/entities';
import { IParameter } from '@games/interfaces';

@Injectable({
  providedIn: 'root',
})
export class ParameterService {
  constructor(private http: HttpClient) {}

  getParameters(
    courseId: number,
    gameId: number,
    filters: HttpParams | { [params: string]: string | string[] } = {},
    isSilentLoader = false
  ) {
    return this.http
      .get<any>(`${environment.apiUrl}courses/${courseId}/games/${gameId}/parameters/`, {
        params: filters,
        headers: { 'silent-loader': isSilentLoader ? 'true' : 'false' },
      })
      .pipe(
        map(parameters =>
          Object.values(parameters).map((parameter: IParameter) => new Parameter(parameter))
        )
      );
  }

  updateParameter(courseId: number, gameId: number, modifiedParameter: any) {
    return this.http.post<any>(
      `${environment.apiUrl}courses/${courseId}/games/${gameId}/parameters/`,
      modifiedParameter
    );
  }
}
